import KeyAccountLayout from "@/layouts/KeyAccountLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/views/DashboardView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "dashboard",
      requiresAuth: true,
      permissions: ["KEY_ACCOUNT_ACCOUNT_READ_PERMISSION"],
    },
  },
];

export default dashboardRoutes;
